import React, {Component} from 'react';
import PropTypes from "prop-types";

class ErrorBoundary extends Component {
  static defaultProps = {
    FallbackComponent: () => "Something went wrong.",
  };

  state = {
    error: null,
    info: null,
  };

  componentDidCatch(error, info) {
    console.error(error, info);
    this.setState({error, info});
  }

  render() {
    const {children, FallbackComponent} = this.props;
    const {error, info} = this.state;

    if (error !== null) {
      return (
        <FallbackComponent
          error={error}
          info={info}
        />
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
  FallbackComponent: PropTypes.any
}

export const withErrorBoundary = (
  Component,
  FallbackComponent
) => props => (
  <ErrorBoundary FallbackComponent={FallbackComponent}>
    <Component {...props} />
  </ErrorBoundary>
);

export default withErrorBoundary;



// WEBPACK FOOTER //
// ./modules/Errors/components/withErrorBoundry.js